/// <reference path='../_all.ts' />

module navigation {
  'use strict';

  export class LoadingIndicatorService {
    
    private _asyncTaskCount: number = 0;
    private _isLoading: boolean = false;

    public static $inject = [
      '$rootScope',
      'debounce',
    ];

    constructor(
      private $rootScope: ng.IRootScopeService,
      private debounce:  navigation.IDebounceService
      ) {

      this.debouncedShowIndicator = debounce(this.debouncedShowIndicator, 400, false);
      this.debouncedHideIndicator = debounce(this.debouncedHideIndicator, 200, false);
      
    }
    
    public taskStarted() :void {
      this._asyncTaskCount++;
      this.debouncedShowIndicator();
    }

    public taskEnded() :void { 
      this._asyncTaskCount--;
      this.debouncedHideIndicator();
    }

    public debouncedShowIndicator() {
      if (this._isLoading) return;
      if (this._asyncTaskCount == 0) return; //other tasks running?
      this.UpdateLoadIndicator(true);
    }

    public debouncedHideIndicator() {
      if (!this._isLoading) return;
      if (this._asyncTaskCount > 0) return; //last task?
      this.UpdateLoadIndicator(false);
    }

    
    public UpdateLoadIndicator(isLoading : boolean) :void{ 
      this._isLoading = isLoading;      
      this.$rootScope.$emit('load-indicator-changed', isLoading);
    }

    public subscribeOnLoadIndicatorChanged(
      scope : ng.IScope
      , callback: (event: ng.IAngularEvent, isLoading : boolean) => void
      ) : void {

      var handler = this.$rootScope.$on('load-indicator-changed', callback);      
      if (scope) scope.$on('$destroy', handler);
    }


  }
}